module.exports = __webpack_public_path__ + "static/media/max3d_new.6a5f5cc7.mp3";